'use client'

import React, { useState } from 'react'
import PropTypes from 'prop-types'

export const FaqComponent = ({ item, index }) => {

    const [showAnswer, setShowAnswer] = useState(false)

    return (
        <div>
            <input
                type="checkbox"
                id={`faq-${index}`}
                name="faq"
                className="hidden peer"
                checked={showAnswer}
                onChange={() => setShowAnswer(state => !state)}
            />
            <label
                className="flex items-center justify-between md:py-6 m-0 cursor-pointer py-8 text-2xl font-bold"
                htmlFor={`faq-${index}`}
            >
                <h1 className="mr-8">{item?.question}</h1>
                <div>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className={`${showAnswer ? "rotate-0" : "rotate-45"} w-6 h-6 transition-all duration-500`}
                        viewBox="0 0 24 24"
                    >
                        <path
                            fill="none"
                            stroke="#454545"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M18 6L6 18M6 6l12 12"
                        />
                    </svg>
                </div>
            </label>
            <div className="md:text-sm text-xl max-h-0 overflow-hidden transition-all duration-500 peer-checked:max-h-screen">
                <p className="md:pt-4 md:pb-10 pt-8 pb-16">{item?.answer}</p>
            </div>
        </div>
    )
}

FaqComponent.propTypes = {
    item: PropTypes.object,
    index: PropTypes.number,
}